import * as React from "react";

const SvgHamburgerMenu = props => <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2 19h17.778v-2.333H2V19zm0-5.833h20v-2.334H2v2.334zM2 5v2.333h16.667V5H2z" /></svg>;

export default SvgHamburgerMenu;